<template>
  <div class="layerWrapper active" style="display: block;" tabindex="0">
    <div class="cbox layerBox popWidM" ref="layerBox" :style="{'display': 'block', 'opacity': '1', ...style}">
      <div class="cart-popup__dialog pf23-itemAgreePop">
        <!-- 팝업 헤더(헤더 텍스트 & 닫기 버튼) -->
        <div class="cart-popup__header" v-if="showHeader">
          <span class="cart-popup__header-text" style="color:#2c2c2c;">
            {{ headerText }}
            <a @click="closePopup" data-dismiss="modal" aria-label="Close" aria-hidden="true" class="cart-popup__close">
              <img src="@/views/survey2/images/NCAcmi_close.png" alt="닫기">
            </a>
          </span>
        </div>
        <!-- 팝업 콘텐츠(컴포넌트) -->
        <div class="cart-popup__content payment">
          <slot></slot>
        </div>
        <!-- 팝업 하단 확인(닫기) 버튼 -->
        <div v-if="showConfirmBtn"
          class="cart-popup__item-link" style="border:none;">
          <a @click="closePopup" class="bt-akl-blue btn_close NCAcmi_cont03_popup">확인</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { SURVEY_SINGAPORE } from '@/store/actions/survey'
import { PopupMixin } from '../mixins'

export default {
  name: 'SurveyPopupLayer',
  mixins: [PopupMixin],
  computed: {
    ...mapState(SURVEY_SINGAPORE, {
      showHeader: state => state.popup.showHeader,
      headerText: state => state.popup.headerText,
      showConfirmBtn: state => state.popup.showConfirmBtn
    })
  },
  mounted() {
    this.htmlEl.classList.add("scrollLock");
    this.uiLayerMask.classList.add("on");
    this.uiLayerMask.style.display = 'block';
    window.addEventListener('resize', this.layerTypeBasic);
    this.layerTypeBasic();
  },
  destroyed() {
    this.htmlEl.classList.remove("scrollLock");
    this.uiLayerMask.classList.remove("on");
    this.uiLayerMask.style.display = 'none';
    window.removeEventListener('resize', this.layerTypeBasic);
  }
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/views/surveys/singapore/components/SurveyPopupLayer.vue